const globalObject = typeof globalThis !== 'undefined' ? globalThis : {};
function resolveRuntime(explicit) {
    if (explicit)
        return explicit;
    if (typeof globalObject.Deno !== 'undefined' && typeof globalObject.Deno.env?.get === 'function') {
        return 'deno';
    }
    if (typeof globalObject.window !== 'undefined') {
        return 'browser';
    }
    return 'node';
}
function uniqueKeys(keys) {
    return Array.from(new Set(keys.filter(Boolean)));
}
function buildCandidateKeys(key, runtime, aliases) {
    const candidates = [];
    if (runtime === 'browser') {
        if (!key.startsWith('VITE_')) {
            candidates.push(`VITE_${key}`);
        }
        candidates.push(key);
    }
    else {
        candidates.push(key);
        if (!key.startsWith('VITE_')) {
            candidates.push(`VITE_${key}`);
        }
    }
    if (aliases && aliases.length > 0) {
        candidates.push(...aliases);
    }
    return uniqueKeys(candidates);
}
function readFromRuntime(key, runtime) {
    switch (runtime) {
        case 'browser': {
            try {
                if (typeof import.meta !== 'undefined' && import.meta.env) {
                    return import.meta.env[key];
                }
            }
            catch {
                return undefined;
            }
            return undefined;
        }
        case 'deno':
            return globalObject.Deno?.env?.get?.(key);
        case 'node':
        default:
            return globalObject.process?.env?.[key];
    }
}
export function getEnvVar(key, options = {}) {
    const runtime = resolveRuntime(options.runtime);
    const candidates = buildCandidateKeys(key, runtime, options.aliases);
    for (const candidate of candidates) {
        const value = readFromRuntime(candidate, runtime);
        if (typeof value !== 'undefined') {
            return value;
        }
    }
    if (typeof options.fallback !== 'undefined') {
        return options.fallback;
    }
    if (options.required) {
        throw new Error(`Missing required environment variable: ${key}`);
    }
    return undefined;
}
export function getRequiredEnvVar(key, options = {}) {
    const value = getEnvVar(key, { ...options, required: true });
    return value;
}
export const detectRuntimeEnvironment = resolveRuntime;
//# sourceMappingURL=env.js.map